// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()
require("@hotwired/turbo-rails")
require("channels")
require("controllers")

import "bootstrap";

import "@fortawesome/fontawesome-free/js/all";
import "../stylesheets/application";
import "../stylesheets/stripe";

import { Turbo } from "@hotwired/turbo-rails";
window.Turbo = Turbo

import 'bootstrap-select/js/bootstrap-select.js';

import { BrowserQRCodeReader } from '@zxing/library';

import 'bootstrap4-tagsinput/tagsinput.js';

import 'jquery_nested_form';

require.context('../images', true)

import flatpickr from "flatpickr"
window.bootbox = require('bootbox');

require ("flatpickr/dist/flatpickr.css")

require("jquery");
global.jQuery, global.$ = require("jquery");

require('./jquery.flexslider-min');

import toastr from 'toastr';
global.toastr = toastr;


import Tagify from '@yaireo/tagify';
global.Tagify = Tagify;

require('packs/events_purchased');
require('packs/cancel_ticket_bootbox');
require('packs/readonly_form');
require('packs/event_orders');

var jstz = require('jstimezonedetect');

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

$(function() {
  $('[data-toggle="tooltip"]').tooltip();
});

$(function() {
  $('[data-toggle="popover"]').popover();
});



var Trix = require("trix")
require("@rails/actiontext")


Trix.config.textAttributes.textColor = {
    styleProperty: "color",
    inheritable: 1
};


(function ($) {
  $.fn.resizeImage = function() {    
    if($(this).hasClass('resize-img')) {      
      if($(this).width() > $(this).height()) {
        $(this).css({'width': 'auto', 'height': '100%'});
      } else if($(this).height() > $(this).width()) {
        $(this).css({'width': '100%', 'height': 'auto'});
      }
      $(this).parent('*').css({"display": "flex", "justify-content": "center", "vertical-align": "middle"});
    }
  }
}(jQuery));

/* insert the button visual in the default toolbar */
addEventListener("trix-initialize", function(event) {
  var buttonHTML = '';
  var icon = '<svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-tag-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">      <path fill-rule="evenodd" d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>    </svg>';

  if (event.target.id == "zevents_event_description") {
    buttonHTML = '<button type="button" id="event_description_text_color" > '+icon+ '</button>';
  } else if (event.target.id == "zevents_event_disclaimer") {
    buttonHTML = '<button type="button" id="event_disclaimer_text_color" >'+icon+ '</button>';
  } else if (event.target.id == "zevents_event_schedule") {
    buttonHTML = '<button type="button" id="event_schedule_text_color" >'+icon+ '</button>';
  } else if (event.target.id == "zevents_trainer_profile_bio")   {
    buttonHTML = '<button type="button" id="trainer_profile_bio_text_color" >'+icon+ '</button>';
  } else{
    buttonHTML = '<button type="button" id="trainer_profile_style_text_color" >'+icon+ '</button>';
  }

  event.target.toolbarElement.querySelector(".trix-button-group").insertAdjacentHTML("beforeend", buttonHTML);
});


// (function() {
//   if ($) {
//     var token = $( 'meta[name="csrf-token"]' ).attr( 'content' );

//     $.ajaxSetup( {
//       beforeSend: function ( xhr ) {
//         xhr.setRequestHeader( 'X-CSRF-Token', token );
//       }
//     });
//   }
// })();


$(function(){
  var $activeClass = $(".admin-events-tabs #myTab a").click(function(){
    $activeClass.removeClass('active');
    $(this).addClass('active');
  });
});

$(document).ready(function (){
  $(function(){
   var $moreDivHeight= $(".existing-cards-wrapper").innerHeight();
    if($moreDivHeight > 230){
      $(".read-more").css({"display":"block"});
      }
  });
   $(".read-more").click(function(){
    $(".existing-cards-wrapper").css({"height":"auto"});
   });

   // $('#accordion .panel-heading').click(function(){
   //  $('.panel-collapse').slideToggle();
   //$('.panel-collapse').css({"display":"block"});
   // });

   var profileNavbar = $(".profiles_show .navbar-collapse");
    profileNavbar.on("click", "a", null, function () {
    profileNavbar.collapse('hide');
   });

   function scrollDown() {
    $('html, body').animate({
        scrollTop: $(window).scrollTop() - 100
    }, 400)
   }

  $('.profile-header #navbarNav li a').click(function(event){
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){
        window.location.hash = hash;
        scrollDown();
      });
    }

    $(this).parents('.navbar-nav').children('li').each(function(){
      $(this).removeClass('active')
    })
    $(this).closest('li').addClass('active');
  })

});

////////////////////////////////////////////////////////////////////////////////////////////
// Spinner related code - begin
//
window.show_spinner = () => $('#mySpinner').show();
window.hide_spinner = () => setTimeout(() => $('#mySpinner').hide(), 100);

// When page loads, hide the spinner
$(document).on("turbo:load", function() {
  window.hide_spinner();
  var timezone = jstz.determine().name();
  document.cookie = 'timezone='+timezone+"; path=/";
});

// When page unloads, show the spinner
window.onunload = () => window.show_spinner();

// Below is for Turbolinks
document.addEventListener("turbo:request-start", () => window.show_spinner());
document.addEventListener("turbo:request-end",   () => window.hide_spinner());
document.addEventListener("turbo:submit-end",    () => window.hide_spinner());

// Below is for ajax calls fired using $.ajax
$(document).ajaxStart(() => window.show_spinner());
$(document).ajaxStop(()  => window.hide_spinner());

// Below is for Forms submitted by rails-ujs via ajax (via data-remote='true')
$(document).on("turbo:load", function() {
  window.addAjaxLoaderHandler();
});
window.addAjaxLoaderHandler = function() {
  $(document).on('ajax:send', (event) => {
    // https://guides.rubyonrails.org/working_with_javascript_in_rails.html#rails-ujs-event-handlers
    // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/onreadystatechange
    // const xhr = event.detail[0];
    // xhr.onreadystatechange = function() {
    //   if (xhr.readyState === XMLHttpRequest.DONE) {
    //     window.hide_spinner();
    //   }
    // };

    window.show_spinner();
    setTimeout(() => window.hide_spinner(), 1000);
  });

  // $(document).on('ajax:complete', (event) => {
  //   window.hide_spinner();
  // });

  // $(document).ajaxSend(function(event, xhr, settings) {
  //   window.show_spinner();
  // });

  // $(document).ajaxComplete(function(event, xhr, settings) {
  //   window.hide_spinner();
  // });
}

// Below is for normal form submissions
$(document).on("turbo:load", function() {
  $('form').on('submit',function(e) {
    window.show_spinner();
  });
});

//
// Spinner related code - end
////////////////////////////////////////////////////////////////////////////////////////////

// v1
document.addEventListener("turbo:load", () => {
  addFlatPickr();
})

global.addFlatPickr = (container='') => {
  $(container || 'body').find("[data-behaviour='flatpickr']").flatpickr({
    altInput: true,
    altFormat: "F j, Y",
    dateFormat: "Y-m-d"
  });

  $(container || 'body').find("[data-behaviour='flatpickr_datetime']").flatpickr({
    altInput: true,
    enableTime: true,
    altFormat: "F j, Y h:i K",
    dateFormat: "Y-m-d h:i K"
  });

  $(container || 'body').find("[data-behaviour='flatpickr_time']").flatpickr({
    altInput: true,
    enableTime: true,
    noCalendar: true,
    altFormat: "H:i",
    dateFormat: "Y-m-d h:i K"
  });
}


import "controllers"
